import { createListLoadingReducer } from './utils';
import { Currency } from '@/types';

export default createListLoadingReducer<Currency>('CURRENCIES');
